// @flow
/*
 * languages 
 */
export const GET_LANGUAGES = "GET_LANGUAGES";
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_ERROR = "GET_LANGUAGES_ERROR";
export const SELECT_LANGUAGE = "SELECT_LANGUAGE";
export const SET_BROWSER_LANGUAGE = "SET_BROWSER_LANGUAGE";
/*
 * auth 
 */
export const LOGIN = "LOGIN";
export const LOGIN_WITH_TOKEN = "LOGIN_WITH_TOKEN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const RECOVER_PASSWORD = "RECOVER_PASSWORD";
export const RECOVER_PASSWORD_SUCCESS = "RECOVER_PASSWORD_SUCCESS";
export const RECOVER_PASSWORD_ERROR = "RECOVER_PASSWORD_ERROR";
/*
 * filters 
 */
export const GET_MAIN_FILTERS = "GET_MAIN_FILTERS";
export const GET_MAIN_FILTERS_SUCCESS = "GET_MAIN_FILTERS_SUCCESS";
export const GET_MAIN_FILTERS_ERROR = "GET_MAIN_FILTERS_ERROR";
export const GET_FILTERS_BY_TYPOLOGY = "GET_FILTERS_BY_TYPOLOGY";
export const GET_FILTERS_BY_TYPOLOGY_SUCCESS =
  "GET_FILTERS_BY_TYPOLOGY_SUCCESS";
export const GET_FILTERS_BY_TYPOLOGY_ERROR = "GET_FILTERS_BY_TYPOLOGY_ERROR";

/*
 * searchString 
 */
export const SET_SEARCH_STRING = "SET_SEARCH_STRING";
/*
 * typologies 
 */
export const SET_TYPOLOGY = "SET_TYPOLOGY";
export const TOGGLE_TYPOLOGY_ON_SELECTED_LIST =
  "TOGGLE_TYPOLOGY_ON_SELECTED_LIST";
/*
 * markets 
 */
export const SET_MARKET = "SET_MARKET";
export const TOGGLE_MARKET_ON_SELECTED_LIST = "TOGGLE_MARKET_ON_SELECTED_LIST";
/*
 * categories 
 */
export const SELECT_CATEGORY = "SELECT_CATEGORY";
/*
 * properties 
 */
export const SELECT_PROPERTY = "SELECT_PROPERTY";
/*
 * tags 
 */
export const SELECT_TAG = "SELECT_TAG";
/*
 * items 
 */
export const SEARCH_ITEMS = "SEARCH_ITEMS";
export const SEARCH_ITEMS_SUCCESS = "SEARCH_ITEMS_SUCCESS";
export const SEARCH_ITEMS_ERROR = "SEARCH_ITEMS_ERROR";
export const GET_NEXT_PAGE_FOR_ITEMS = "GET_NEXT_PAGE_FOR_ITEMS";
export const RESET_PAGE_FOR_ITEMS = "RESET_PAGE_FOR_ITEMS";
export const SELECT_ITEM = "SELECT_ITEM";
export const GET_ITEM_BY_ID = "GET_ITEM_BY_ID";
export const GET_ITEM_BY_ID_SUCCESS = "GET_ITEM_BY_ID_SUCCESS";
export const GET_ITEM_BY_ID_ERROR = "GET_ITEM_BY_ID_ERROR";
export const TOGGLE_EDIT_MODE = "TOGGLE_EDIT_MODE";
export const UNPUBLISH_ITEM = "UNPUBLISH_ITEM";
export const UNPUBLISH_ITEM_SUCCESS = "UNPUBLISH_ITEM_SUCCESS";
export const UNPUBLISH_ITEM_ERROR = "UNPUBLISH_ITEM_ERROR";
export const REMOVE_TAG_FROM_ITEM = "REMOVE_TAG_FROM_ITEM";
export const REMOVE_TAG_FROM_ITEM_SUCCESS = "REMOVE_TAG_FROM_ITEM_SUCCESS";
export const REMOVE_TAG_FROM_ITEM_ERROR = "REMOVE_TAG_FROM_ITEM_ERROR";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js